module.exports = __webpack_public_path__ + "static/media/facebook.8a41b3ce.svg";